import { FindControlSearchParameterItemDto } from './FindControlSearchParameterItemDto';

export enum FindControlAdditionalSearchParametersType {
  // All columns are combined with AND.
  Standard = 'Standard',
  // Columns are grouped by name. Multiple values for the same column are combined with OR. The groups are combined with AND.
  MultipleValues = 'MultipleValues',
}

export interface FindControlAdditionalSearchParametersDto {
  Type: FindControlAdditionalSearchParametersType;
  AdditionalSearchParameters: FindControlSearchParameterItemDto[];
}
